import { Field, Formik } from "formik";
import moment from "moment";
import { useEffect, useState } from "react";
import { Alert, Button, Card, Col, Form, Jumbotron, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import * as Yup from 'yup';
import Get from "../../api/Get";
import { GET_DOCTOR_BY_SPECIALITY_ACCOUNT_SIN_TOKEN } from "../../api/Routes";
import SimpleLoad from "../../loader/SimpleLoad";
import ItemsDoctors from "../ItemsDoctors";

function StepTwoAutoagendamiento({t, next, initialData, setInitialData, prev, speciality, setShowModalError, setErrorServer}){
    const [especialidad, setEspecialidad]=useState(speciality)
    const [items, setItems] = useState([])
    const [isSearch, setIsSearch] = useState(false)

    const [currentPage, setCurrentPage] = useState(1);
    const [pageCount, setPageCount] = useState(0)
    const postsPerPage = 10;
    const indexOfLastPost = currentPage * postsPerPage;
    const indexOfFirstPost = indexOfLastPost - postsPerPage;


    const handleSubmit = (values) =>{
        next(values)
    }

    const handlePageClick = (data) =>{
        setCurrentPage(data.selected+1)
    }

    const onClickShowCitaPatient = (hour, date, idHour, doctorId) =>{
        let d = items.filter(e=>e.doctor.id===doctorId)
        setInitialData(prev=>({
            ...prev,
            dayAppointment: date, 
            doctorId: doctorId,
            hourDayId: idHour,
            hourDayHour: hour,
            doctorName: `${d[0].doctor.name} ${d[0].doctor.lastName}`,
            especialidadName: especialidad.name,
            especialidadId: especialidad.id
        }))
    }

    const shemaValidateStepOne = Yup.object().shape({
        hourInit: Yup.string()
           .required(t('Camporequerido')),
        doctorId: Yup.string()
          .required(t('Camporequerido'))
    });

    useEffect(()=>{
        //console.log(especialidad)
        let mounted = true;
        setIsSearch(true)
        Get({url: `${GET_DOCTOR_BY_SPECIALITY_ACCOUNT_SIN_TOKEN}/${speciality.id}/${initialData.account.id}`, noToken: true})
        .then(response=>{
            if(mounted){
                setItems(response.data.data.response)
                if(response.data.data.response.length > 0){
                    let pC = Math.ceil(response.data.data.response.length / postsPerPage)
                    setPageCount(pC)
                }
                setIsSearch(false)
            }
        }) 
        .catch(error=>{
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
        }) 
    }, [])

    const onClickSelectedSchedule = (horario, doctorId) =>{
        let d = items.filter(e=>e.doctor.id===doctorId)
        //console.log(d)
        let schedule = {
            scheduleType:"Online",
            doctor: {
              id: doctorId
            },
            hourInit: moment(horario.dateTimeInit, "YYYY-MM-DDTHH:mm:ss").format("DD-MM-YYYY HH:mm:ss")
        }
        setInitialData(prev=>({
            ...prev,
            hourInit: moment(horario.dateTimeInit, "YYYY-MM-DDTHH:mm:ss").format("DD-MM-YYYY HH:mm:ss"),
            schedule: schedule,
            doctorId: doctorId,
            doctorName: `${d[0].doctor.name} ${d[0].doctor.lastName}`,
            especialidadName: d[0].especialty.name,
            especialidadId: d[0].especialty.id
        }))
    }
    

    return (
        <Formik
            initialValues={initialData}
            validationSchema={shemaValidateStepOne}
            onSubmit={handleSubmit}
            enableReinitialize={true}
        >{({
            errors,
            handleSubmit,
            setFieldValue
        })=>(
            <Form onSubmit={handleSubmit}>
                <Field type="hidden" name="dayAppointment" value={initialData.dayAppointment} />
                <Field type="hidden" name="doctorId" value={initialData.doctorId} />
                <Field type="hidden" name="hourDayId" value={initialData.hourDayId} />
                <Card className="mb-3">
                    <Card.Body>
                        { 
                            (errors.hourInit || errors.doctorId) && 
                            <Alert variant="danger">{t('seleccionar_horario')}</Alert> 
                        }
                        {
                            initialData.schedule &&
                            <div className="alert-info p-3 rounded">
                                <label>{t('cita_seleccionada')}</label>
                                <h6 className="mb-0">{t('doctor')}: {initialData.doctorName}</h6>
                                <h6 className="mb-0">{t('fecha')}: {moment(initialData.schedule.hourInit, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY HH:mm")} hrs</h6>
                            </div>                            
                        }
                        {
                            isSearch ? 
                            <Row>
                                <Col className="position-relative overflow-hidden h-300px">
                                    <SimpleLoad />
                                </Col>
                            </Row> :
                            <Row>
                                {
                                    (items.length === 0 && especialidad != null) ?
                                    <Col>
                                        <Jumbotron>
                                            <h1 className="display-3">{t('lo_sentimos')}</h1>
                                            <p>{t('not_found_expecialidad')}</p>
                                        </Jumbotron>
                                    </Col> :
                                    <Col className="text-style">
                                        <ItemsDoctors 
                                            items={items} 
                                            handlePageClick={handlePageClick}
                                            indexOfLastPost={indexOfLastPost}
                                            indexOfFirstPost={indexOfFirstPost}
                                            pageCount={pageCount}
                                            onClickShowCitaPatient={onClickShowCitaPatient}
                                            auth={null}
                                            publico={true}
                                            account={initialData.account}
                                            onClickSelectedSchedule={onClickSelectedSchedule}
                                            company={initialData.company}
                                            countDr={0}
                                        />
                                    </Col>
                                }
                                
                            </Row>
                        }
                        
                        <Row className="mt-3">
                            <Col className="text-right">
                                <Button type="button" variant="primary" className="btn1" onClick={prev}>{t('regresar')}</Button>{' '}
                                <Button type="submit" variant="primary" className="btn1">{t('siguiente')}</Button>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            </Form>
        )}

        </Formik>
    )


}

export default withTranslation()(StepTwoAutoagendamiento)